import InvitationCard from './container';

export default InvitationCard;



// WEBPACK FOOTER //
// ./src/components/Cards/InvitationCard/index.js